<template>
  <div>

    <div class="bannerImg"></div>
    <div class="lable">粘贴或输入文本</div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label-width='0' prop="exportContent">
        <el-input type="textarea" :validate-event=true :rows="8" :show-word-limit=true :maxlength=2000 :minlength=50
          class="input" placeholder="" v-model="ruleForm.exportContent">

        </el-input>
        <el-link style="position: absolute;
        font-size: 12px;
    bottom: -5px;
    width: 93px;
    right: 30px;" :underline="false" @click="ruleForm.exportContent = ''">清空</el-link>
      </el-form-item>
      <div class="desc" style="top:-10px">小弈将根据您推荐的内容自动推荐相关素材</div>
    </el-form>
    <el-row style="clear:both;min-height:20px;text-align:left">

    </el-row>
    <el-button type="primary" @click="genArticle">导入内容</el-button>
  </div>
</template>

<script>

export default {
  name: 'index',
  data: function () {
    return {

      exportContent: '',
      ruleForm: {
        exportContent: ''
      },
      rules: {
        exportContent: [
          { required: true, message: '请输入导入的内容', trigger: 'blur' },
          { min: 50, max: 2000, message: '长度在 50 到 2000 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {

    // 跳转到详情页
    goDetail (articleId) {
      if (articleId) {
        this.$router.push({ path: '/newsEdit', query: { articleId: articleId, from: 'txt' } })
      } else {
        _this.$message.error('写作失败，请换个词试试');
      }
    },

    genArticle () {
      let _this = this
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.axios.postWithLoading('/webApi/v3/robot/uploadContent', { 'title': '', 'content': _this.ruleForm.exportContent }).then((response) => {
            if (response.data.autoNewsId) {
              _this.goDetail(response.data.autoNewsId)
            } else {
              this.$message.error('未写作成功，请编辑内容后重试');
            }
          })
        }
      })
    }
  },
  components: {

  },
  mounted () {

  },
  watch: {

  }
}
</script>

<style lang="less" scoped>
.bannerImg {
  background-image: url('../../assets/imgs/importTextBanner.png');
}
</style>



// WEBPACK FOOTER //
// src/components/write/importText.vue